import create from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Auth Store - Manages user authentication state
 */
export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      isAuthenticated: false,

      // Set user and tokens
      setAuth: (user, accessToken, refreshToken) => {
        set({
          user,
          accessToken,
          refreshToken,
          isAuthenticated: !!accessToken,
        });
      },

      // Clear auth
      logout: () => {
        set({
          user: null,
          accessToken: null,
          refreshToken: null,
          isAuthenticated: false,
        });
      },

      // Initialize auth from localStorage
      initializeAuth: () => {
        const stored = localStorage.getItem('auth-store');
        if (stored) {
          const state = JSON.parse(stored);
          set(state.state || {});
        }
      },

      // Update access token
      setAccessToken: (accessToken) => {
        set({ accessToken, isAuthenticated: !!accessToken });
      },
    }),
    {
      name: 'auth-store',
    }
  )
);
